(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-core'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var VOID = kotlin_kotlin.$_$.g;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.r4;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var emptyList = kotlin_kotlin.$_$.s6;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.jf;
  var toString = kotlin_kotlin.$_$.lb;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var KProperty1 = kotlin_kotlin.$_$.zb;
  var getPropertyCallableRef = kotlin_kotlin.$_$.ea;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.n1;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var captureStack = kotlin_kotlin.$_$.r9;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.p1;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.r1;
  var IllegalArgumentException = kotlin_kotlin.$_$.he;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var KClass = kotlin_kotlin.$_$.vb;
  var isInterface = kotlin_kotlin.$_$.va;
  var Triple = kotlin_kotlin.$_$.pe;
  var getKClass = kotlin_kotlin.$_$.f;
  var Pair = kotlin_kotlin.$_$.le;
  var Entry = kotlin_kotlin.$_$.n5;
  var LinkedHashMap = kotlin_kotlin.$_$.k5;
  var KtMutableMap = kotlin_kotlin.$_$.q5;
  var KtMap = kotlin_kotlin.$_$.o5;
  var HashMap = kotlin_kotlin.$_$.h5;
  var LinkedHashSet = kotlin_kotlin.$_$.l5;
  var KtMutableSet = kotlin_kotlin.$_$.r5;
  var KtSet = kotlin_kotlin.$_$.s5;
  var HashSet = kotlin_kotlin.$_$.i5;
  var ArrayList = kotlin_kotlin.$_$.f5;
  var KtMutableList = kotlin_kotlin.$_$.p5;
  var KtList = kotlin_kotlin.$_$.m5;
  var Collection = kotlin_kotlin.$_$.g5;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.y2;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.w2;
  var Result = kotlin_kotlin.$_$.me;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var equals = kotlin_kotlin.$_$.z9;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var isBlank = kotlin_kotlin.$_$.mc;
  var toList = kotlin_kotlin.$_$.m8;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.l;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.r;
  var toHashSet = kotlin_kotlin.$_$.j8;
  var toBooleanArray = kotlin_kotlin.$_$.i8;
  var withIndex = kotlin_kotlin.$_$.s8;
  var to = kotlin_kotlin.$_$.qf;
  var toMap = kotlin_kotlin.$_$.n8;
  var lazy_0 = kotlin_kotlin.$_$.kf;
  var contentEquals = kotlin_kotlin.$_$.c6;
  var until = kotlin_kotlin.$_$.ub;
  var joinToString = kotlin_kotlin.$_$.i7;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var Long = kotlin_kotlin.$_$.je;
  var Char = kotlin_kotlin.$_$.ae;
  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.k2;
  var Duration = kotlin_kotlin.$_$.yd;
  var Companion_getInstance = kotlin_kotlin.$_$.u4;
  var toIntOrNull = kotlin_kotlin.$_$.ld;
  var hashCode = kotlin_kotlin.$_$.ga;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.m;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.s;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.x;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.o;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.p;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.v;
  var isArray = kotlin_kotlin.$_$.na;
  var arrayIterator = kotlin_kotlin.$_$.p9;
  var asList = kotlin_kotlin.$_$.w5;
  var step = kotlin_kotlin.$_$.tb;
  var getValue = kotlin_kotlin.$_$.d7;
  var longArray = kotlin_kotlin.$_$.ab;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var get_lastIndex = kotlin_kotlin.$_$.k7;
  var countTrailingZeroBits = kotlin_kotlin.$_$.cf;
  var getOrNull = kotlin_kotlin.$_$.b7;
  var fillArrayVal = kotlin_kotlin.$_$.ba;
  var indexOf = kotlin_kotlin.$_$.e7;
  var contentToString = kotlin_kotlin.$_$.e6;
  var Enum = kotlin_kotlin.$_$.ee;
  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.q;
  var toString_0 = kotlin_kotlin.$_$.pf;
  var KTypeParameter = kotlin_kotlin.$_$.ac;
  var booleanArray = kotlin_kotlin.$_$.q9;
  var emptyMap = kotlin_kotlin.$_$.t6;
  var contentHashCode = kotlin_kotlin.$_$.d6;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.w4;
  var isCharArray = kotlin_kotlin.$_$.qa;
  var charArray = kotlin_kotlin.$_$.t9;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.n4;
  var isDoubleArray = kotlin_kotlin.$_$.sa;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.o4;
  var isFloatArray = kotlin_kotlin.$_$.ta;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.x4;
  var isLongArray = kotlin_kotlin.$_$.wa;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.b5;
  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.y3;
  var ULongArray = kotlin_kotlin.$_$.ue;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.u3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.r3;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.w3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.s3;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.p4;
  var isIntArray = kotlin_kotlin.$_$.ua;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.a5;
  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.p3;
  var UIntArray = kotlin_kotlin.$_$.se;
  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.l3;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.i3;
  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.n3;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.j3;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.q4;
  var isShortArray = kotlin_kotlin.$_$.xa;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.c5;
  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.h4;
  var UShortArray = kotlin_kotlin.$_$.we;
  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.d4;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.a4;
  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.f4;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.b4;
  var ByteCompanionObject_instance = kotlin_kotlin.$_$.m4;
  var isByteArray = kotlin_kotlin.$_$.pa;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.z4;
  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.g3;
  var UByteArray = kotlin_kotlin.$_$.qe;
  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.d3;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.z2;
  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.e3;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.a3;
  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.l4;
  var isBooleanArray = kotlin_kotlin.$_$.oa;
  var coerceAtLeast = kotlin_kotlin.$_$.ob;
  var copyOf = kotlin_kotlin.$_$.i6;
  var copyOf_0 = kotlin_kotlin.$_$.k6;
  var copyOf_1 = kotlin_kotlin.$_$.l6;
  var copyOf_2 = kotlin_kotlin.$_$.g6;
  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.z3;
  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.v3;
  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.x3;
  var copyOf_3 = kotlin_kotlin.$_$.n6;
  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.q3;
  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.m3;
  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.o3;
  var copyOf_4 = kotlin_kotlin.$_$.f6;
  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.i4;
  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.e4;
  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.g4;
  var copyOf_5 = kotlin_kotlin.$_$.j6;
  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.h3;
  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.c3;
  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.f3;
  var copyOf_6 = kotlin_kotlin.$_$.h6;
  var Unit = kotlin_kotlin.$_$.ye;
  var trimIndent = kotlin_kotlin.$_$.vd;
  var equals_0 = kotlin_kotlin.$_$.hc;
  var charSequenceLength = kotlin_kotlin.$_$.v9;
  var charSequenceGet = kotlin_kotlin.$_$.u9;
  var toString_1 = kotlin_kotlin.$_$.t2;
  var titlecase = kotlin_kotlin.$_$.id;
  var isLowerCase = kotlin_kotlin.$_$.qc;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.t4;
  var ULong = kotlin_kotlin.$_$.ve;
  var UInt = kotlin_kotlin.$_$.te;
  var UShort = kotlin_kotlin.$_$.xe;
  var UByte = kotlin_kotlin.$_$.re;
  var mapOf = kotlin_kotlin.$_$.s7;
  var lastOrNull = kotlin_kotlin.$_$.n7;
  var get_lastIndex_0 = kotlin_kotlin.$_$.l7;
  var get_js = kotlin_kotlin.$_$.za;
  var findAssociatedObject = kotlin_kotlin.$_$.d;
  var get_indices = kotlin_kotlin.$_$.g7;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var get_indices_0 = kotlin_kotlin.$_$.f7;
  var Companion_instance = kotlin_kotlin.$_$.y4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.u2;
  var createFailure = kotlin_kotlin.$_$.df;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
  initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
  initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
  initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForInterface(StringFormat, 'StringFormat');
  initMetadataForInterface(BinaryFormat, 'BinaryFormat');
  initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
  initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
  initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(elementDescriptors$1$1);
  initMetadataForClass(_no_name_provided__qut3iv);
  initMetadataForClass(elementNames$1$1);
  initMetadataForClass(_no_name_provided__qut3iv_0);
  initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
  initMetadataForInterface(CachedNames, 'CachedNames');
  initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(SerialKind, 'SerialKind');
  initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
  initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
  initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
  initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
  initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
  initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
  initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
  initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
  initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
  initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
  initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
  initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
  initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
  initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
  initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
  initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
  initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
  initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
  initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
  initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.v1d(this);
  }
  initMetadataForInterface(Decoder, 'Decoder');
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.j1h(descriptor, index, deserializer, previousValue) : $super.j1h.call(this, descriptor, index, deserializer, previousValue);
  }
  initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
  initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.x1g(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.u1d(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.t1d().w1e();
    if (isNullabilitySupported) {
      return this.o1i(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.r1h();
    } else {
      this.r1i();
      this.o1i(serializer, value);
    }
  }
  initMetadataForInterface(Encoder, 'Encoder');
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
  initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
  initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ElementMarker, 'ElementMarker');
  initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
  initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
  initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
  initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForInterface(SerializerFactory, 'SerializerFactory');
  initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
  initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
  initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerializersModule, 'SerializersModule');
  initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
  initMetadataForClass(ContextualProvider, 'ContextualProvider');
  initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
  initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.k1x(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
  initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
  initMetadataForClass(createCache$1);
  initMetadataForClass(createParametrizedCache$1);
  //endregion
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.e1e('type', serializer_1(StringCompanionObject_instance).t1d());
      $this$buildSerialDescriptor.e1e('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.f1e_1.p9() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.y1d_1 = this$0.g1e_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.f1e_1);
    };
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.f1e_1 = baseClass;
    this.g1e_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h1e_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).i1e = function () {
    return this.f1e_1;
  };
  protoOf(PolymorphicSerializer).t1d = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h1e_1;
    descriptor$factory();
    return this_0.v();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.f1e_1) + ')';
  };
  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.l1e(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.i1e());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.k1e(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.i1e());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function descriptor$factory() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.t1d();
    }, null);
  }
  function SealedClassSerializer() {
  }
  function StringFormat() {
  }
  function BinaryFormat() {
  }
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.j() === 1 ? "Field '" + missingFields.p(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.r1e_1 = missingFields;
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator = typeArguments.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp$ret$0 = serializer(_this__u8e3s4, item);
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator_0 = typeArguments.g();
      while (tmp0_iterator_0.h()) {
        var item_0 = tmp0_iterator_0.i();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$3 = tmp_0;
        destination_0.e(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function serializer(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(KtList))) ? true : _this__u8e3s4.equals(getKClass(KtMutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) {
      tmp = new ArrayListSerializer(serializers.p(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.p(0));
    } else if ((_this__u8e3s4.equals(getKClass(KtSet)) ? true : _this__u8e3s4.equals(getKClass(KtMutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) {
      tmp = new LinkedHashSetSerializer(serializers.p(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.p(0), serializers.p(1));
    } else if ((_this__u8e3s4.equals(getKClass(KtMap)) ? true : _this__u8e3s4.equals(getKClass(KtMutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) {
      tmp = new LinkedHashMapSerializer(serializers.p(0), serializers.p(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.p(0), serializers.p(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.p(0), serializers.p(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.p(0), serializers.p(1), serializers.p(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.p(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.fa();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.ea();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        var value = item.zf_1;
        // Inline function 'kotlin.contracts.contract' call
        if (value == null) {
          // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>.<anonymous>' call
          var message = 'Star projections in type arguments are not allowed, but had ' + toString(type);
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          tmp$ret$1 = value;
          break $l$block;
        }
      }
      var tmp$ret$2 = tmp$ret$1;
      destination.e(tmp$ret$2);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.o()) {
      tmp = findCachedSerializer(rootClass, isNullable);
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_0;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_0 = null;
      } else {
        var tmp_1 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_0 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
      }
      tmp = tmp_0;
    }
    var cachedSerializer = tmp;
    if (cachedSerializer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return cachedSerializer;
    }
    var tmp_2;
    if (typeArguments.o()) {
      tmp_2 = _this__u8e3s4.t1e(rootClass);
    } else {
      var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      var serializers = tmp_3;
      var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      tmp_2 = tmp2_elvis_lhs == null ? _this__u8e3s4.s1e(rootClass, serializers) : tmp2_elvis_lhs;
    }
    var contextualSerializer = tmp_2;
    var tmp_4;
    if (contextualSerializer == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_4 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp4_safe_receiver = tmp_4;
    return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializer_0(_this__u8e3s4) {
    var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.p(0).da();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().u1e(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().u1e(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().v1e(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().v1e(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    return serializerOrNull(it);
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_safe_receiver = serializerOrNull(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.p(0).da();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.p(0).da();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.t1d().w1e()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function serializer_1(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_2(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_3(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_5(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function SetSerializer(elementSerializer) {
    return new LinkedHashSetSerializer(elementSerializer);
  }
  function withContext(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function ContextDescriptor(original, kClass) {
    this.x1e_1 = original;
    this.y1e_1 = kClass;
    this.z1e_1 = this.x1e_1.a1f() + '<' + this.y1e_1.p9() + '>';
  }
  protoOf(ContextDescriptor).b1f = function () {
    return this.x1e_1.b1f();
  };
  protoOf(ContextDescriptor).c1f = function () {
    return this.x1e_1.c1f();
  };
  protoOf(ContextDescriptor).d1f = function () {
    return this.x1e_1.d1f();
  };
  protoOf(ContextDescriptor).w1e = function () {
    return this.x1e_1.w1e();
  };
  protoOf(ContextDescriptor).e1f = function () {
    return this.x1e_1.e1f();
  };
  protoOf(ContextDescriptor).f1f = function (index) {
    return this.x1e_1.f1f(index);
  };
  protoOf(ContextDescriptor).g1f = function (index) {
    return this.x1e_1.g1f(index);
  };
  protoOf(ContextDescriptor).h1f = function (name) {
    return this.x1e_1.h1f(name);
  };
  protoOf(ContextDescriptor).i1f = function (index) {
    return this.x1e_1.i1f(index);
  };
  protoOf(ContextDescriptor).j1f = function (index) {
    return this.x1e_1.j1f(index);
  };
  protoOf(ContextDescriptor).a1f = function () {
    return this.z1e_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.x1e_1, another.x1e_1) && another.y1e_1.equals(this.y1e_1);
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.y1e_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.z1e_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + toString(this.y1e_1) + ', original: ' + toString(this.x1e_1) + ')';
  };
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.t1e(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.t1d();
    }
    return tmp;
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.y1e_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.k1f_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function SerialDescriptor() {
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(_this__u8e3s4);
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(_this__u8e3s4);
  }
  function elementDescriptors$1$1($this_elementDescriptors) {
    this.o1f_1 = $this_elementDescriptors;
    this.n1f_1 = $this_elementDescriptors.c1f();
  }
  protoOf(elementDescriptors$1$1).h = function () {
    return this.n1f_1 > 0;
  };
  protoOf(elementDescriptors$1$1).i = function () {
    var tmp = this.o1f_1.c1f();
    var tmp1 = this.n1f_1;
    this.n1f_1 = tmp1 - 1 | 0;
    return this.o1f_1.g1f(tmp - tmp1 | 0);
  };
  function _no_name_provided__qut3iv($this_elementDescriptors) {
    this.p1f_1 = $this_elementDescriptors;
  }
  protoOf(_no_name_provided__qut3iv).g = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1$1(this.p1f_1);
  };
  function elementNames$1$1($this_elementNames) {
    this.r1f_1 = $this_elementNames;
    this.q1f_1 = $this_elementNames.c1f();
  }
  protoOf(elementNames$1$1).h = function () {
    return this.q1f_1 > 0;
  };
  protoOf(elementNames$1$1).i = function () {
    var tmp = this.r1f_1.c1f();
    var tmp1 = this.q1f_1;
    this.q1f_1 = tmp1 - 1 | 0;
    return this.r1f_1.i1f(tmp - tmp1 | 0);
  };
  function _no_name_provided__qut3iv_0($this_elementNames) {
    this.s1f_1 = $this_elementNames;
  }
  protoOf(_no_name_provided__qut3iv_0).g = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
    return new elementNames$1$1(this.s1f_1);
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!equals(kind, CLASS_getInstance())) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.z1d_1.j(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.w1d_1 = serialName;
    this.x1d_1 = false;
    this.y1d_1 = emptyList();
    this.z1d_1 = ArrayList_init_$Create$_0();
    this.a1e_1 = HashSet_init_$Create$();
    this.b1e_1 = ArrayList_init_$Create$_0();
    this.c1e_1 = ArrayList_init_$Create$_0();
    this.d1e_1 = ArrayList_init_$Create$_0();
  }
  protoOf(ClassSerialDescriptorBuilder).t1f = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.a1e_1.e(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.w1d_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.z1d_1.e(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.b1e_1.e(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.c1e_1.e(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.d1e_1.e(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).e1e = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.t1f(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.t1f.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.z1d_1.j(), toList(typeParameters), sdBuilder);
  }
  function _get__hashCode__tgwhef($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.f1g_1;
    _hashCode$factory();
    return this_0.v();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.e1g_1);
    };
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.i1f(it) + ': ' + this$0.g1f(it).a1f();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.u1f_1 = serialName;
    this.v1f_1 = kind;
    this.w1f_1 = elementsCount;
    this.x1f_1 = builder.y1d_1;
    this.y1f_1 = toHashSet(builder.z1d_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.z1d_1;
    tmp.z1f_1 = copyToArray(this_0);
    this.a1g_1 = compactArray(builder.b1e_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.c1e_1;
    tmp_0.b1g_1 = copyToArray(this_1);
    this.c1g_1 = toBooleanArray(builder.d1e_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.z1f_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.ld_1, item.kd_1);
      destination.e(tmp$ret$2);
    }
    tmp_1.d1g_1 = toMap(destination);
    this.e1g_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.f1g_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).a1f = function () {
    return this.u1f_1;
  };
  protoOf(SerialDescriptorImpl).e1f = function () {
    return this.v1f_1;
  };
  protoOf(SerialDescriptorImpl).c1f = function () {
    return this.w1f_1;
  };
  protoOf(SerialDescriptorImpl).b1f = function () {
    return this.x1f_1;
  };
  protoOf(SerialDescriptorImpl).g1g = function () {
    return this.y1f_1;
  };
  protoOf(SerialDescriptorImpl).i1f = function (index) {
    return getChecked(this.z1f_1, index);
  };
  protoOf(SerialDescriptorImpl).h1f = function (name) {
    var tmp0_elvis_lhs = this.d1g_1.y1(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(SerialDescriptorImpl).f1f = function (index) {
    return getChecked(this.b1g_1, index);
  };
  protoOf(SerialDescriptorImpl).g1f = function (index) {
    return getChecked(this.a1g_1, index);
  };
  protoOf(SerialDescriptorImpl).j1f = function (index) {
    return getChecked_0(this.c1g_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.a1f() === other.a1f())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.e1g_1, other.e1g_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.c1f() === other.c1f())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.c1f();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.g1f(index).a1f() === other.g1f(index).a1f())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.g1f(index).e1f(), other.g1f(index).e1f())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.w1f_1);
    var tmp_0 = this.u1f_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function buildSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function buildClassSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef(receiver);
    }, null);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).p9());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).h1g = function () {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).i1g = function () {
    return true;
  };
  protoOf(AbstractDecoder).j1g = function () {
    return null;
  };
  protoOf(AbstractDecoder).k1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).l1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).m1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).n1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).o1g = function () {
    var tmp = this.h1g();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).p1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).q1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).r1g = function () {
    var tmp = this.h1g();
    return tmp instanceof Char ? tmp.f1_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).s1g = function () {
    var tmp = this.h1g();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).t1g = function (enumDescriptor) {
    var tmp = this.h1g();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).u1g = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).v1g = function (deserializer, previousValue) {
    return this.w1g(deserializer);
  };
  protoOf(AbstractDecoder).x1g = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).y1g = function (descriptor) {
  };
  protoOf(AbstractDecoder).z1g = function (descriptor, index) {
    return this.k1g();
  };
  protoOf(AbstractDecoder).a1h = function (descriptor, index) {
    return this.l1g();
  };
  protoOf(AbstractDecoder).b1h = function (descriptor, index) {
    return this.m1g();
  };
  protoOf(AbstractDecoder).c1h = function (descriptor, index) {
    return this.n1g();
  };
  protoOf(AbstractDecoder).d1h = function (descriptor, index) {
    return this.o1g();
  };
  protoOf(AbstractDecoder).e1h = function (descriptor, index) {
    return this.p1g();
  };
  protoOf(AbstractDecoder).f1h = function (descriptor, index) {
    return this.q1g();
  };
  protoOf(AbstractDecoder).g1h = function (descriptor, index) {
    return this.r1g();
  };
  protoOf(AbstractDecoder).h1h = function (descriptor, index) {
    return this.s1g();
  };
  protoOf(AbstractDecoder).i1h = function (descriptor, index) {
    return this.u1g(descriptor.g1f(index));
  };
  protoOf(AbstractDecoder).j1h = function (descriptor, index, deserializer, previousValue) {
    return this.v1g(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).l1h = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.t1d().w1e();
    var tmp;
    if (isNullabilitySupported || this.i1g()) {
      // Inline function 'kotlinx.serialization.encoding.AbstractDecoder.decodeNullableSerializableElement.<anonymous>' call
      tmp = this.v1g(deserializer, previousValue);
    } else {
      tmp = this.j1g();
    }
    return tmp;
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).x1g = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).y1g = function (descriptor) {
  };
  protoOf(AbstractEncoder).p1h = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).q1h = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(AbstractEncoder).r1h = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).s1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).t1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).u1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).v1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).w1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).x1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).y1h = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).z1h = function (value) {
    return this.q1h(new Char(value));
  };
  protoOf(AbstractEncoder).a1i = function (value) {
    return this.q1h(value);
  };
  protoOf(AbstractEncoder).b1i = function (enumDescriptor, index) {
    return this.q1h(index);
  };
  protoOf(AbstractEncoder).c1i = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).d1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.s1h(value);
    }
  };
  protoOf(AbstractEncoder).e1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.t1h(value);
    }
  };
  protoOf(AbstractEncoder).f1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.u1h(value);
    }
  };
  protoOf(AbstractEncoder).g1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.v1h(value);
    }
  };
  protoOf(AbstractEncoder).h1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.w1h(value);
    }
  };
  protoOf(AbstractEncoder).i1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.x1h(value);
    }
  };
  protoOf(AbstractEncoder).j1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.y1h(value);
    }
  };
  protoOf(AbstractEncoder).k1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.z1h(value);
    }
  };
  protoOf(AbstractEncoder).l1i = function (descriptor, index, value) {
    if (this.p1h(descriptor, index)) {
      this.a1i(value);
    }
  };
  protoOf(AbstractEncoder).m1i = function (descriptor, index) {
    return this.p1h(descriptor, index) ? this.c1i(descriptor.g1f(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).n1i = function (descriptor, index, serializer, value) {
    if (this.p1h(descriptor, index)) {
      this.o1i(serializer, value);
    }
  };
  protoOf(AbstractEncoder).p1i = function (descriptor, index, serializer, value) {
    if (this.p1h(descriptor, index)) {
      this.q1i(serializer, value);
    }
  };
  function Decoder() {
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.h1h($this.t1d(), 0);
    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
    return compositeDecoder.k1h($this.t1d(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).j1e = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.t1d();
    var composite = encoder.x1g(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.l1i(this.t1d(), 0, actualSerializer.t1d().a1f());
    var tmp = this.t1d();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.n1i(tmp, 1, tmp$ret$0, value);
    composite.y1g(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).u1d = function (encoder, value) {
    return this.j1e(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).v1d = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.t1d();
    var composite = decoder.x1g(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.m1h()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.n1h(this.t1d());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.h1h(this.t1d(), index);
            break;
          case 1:
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              var value_0 = klassName;
              // Inline function 'kotlin.contracts.contract' call
              if (value_0 == null) {
                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException_init_$Create$(toString(message));
              } else {
                tmp$ret$2 = value_0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.k1h(this.t1d(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var value_1 = value;
        // Inline function 'kotlin.contracts.contract' call
        if (value_1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          tmp$ret$4 = value_1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.y1g(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).k1e = function (decoder, klassName) {
    return decoder.o1e().u1i(this.i1e(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).l1e = function (encoder, value) {
    return encoder.o1e().v1i(this.i1e(), value);
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.p9();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope = "in the polymorphic scope of '" + baseClass.p9() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.p9() + "' has to be sealed and '@Serializable'."));
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.w1i_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).t1d = function () {
    return this.w1i_1;
  };
  protoOf(NothingSerializer_0).x1i = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).u1d = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.x1i(encoder, tmp);
  };
  protoOf(NothingSerializer_0).v1d = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.y1i_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).t1d = function () {
    return this.y1i_1;
  };
  protoOf(DurationSerializer).z1i = function (encoder, value) {
    encoder.a1i(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).u1d = function (encoder, value) {
    return this.z1i(encoder, value instanceof Duration ? value.ac_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).a1j = function (decoder) {
    return Companion_getInstance().kg(decoder.s1g());
  };
  protoOf(DurationSerializer).v1d = function (decoder) {
    return new Duration(this.a1j(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).a1f = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).a1f = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).a1f = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).a1f = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.d1j_1 = elementDescriptor;
    this.e1j_1 = 1;
  }
  protoOf(ListLikeDescriptor).e1f = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).c1f = function () {
    return this.e1j_1;
  };
  protoOf(ListLikeDescriptor).i1f = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).h1f = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).j1f = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.a1f() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).f1f = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.a1f() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).g1f = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.a1f() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.d1j_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.d1j_1, other.d1j_1) && this.a1f() === other.a1f())
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.d1j_1), 31) + getStringHashCode(this.a1f()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.a1f() + '(' + toString(this.d1j_1) + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.j1j_1 = serialName;
    this.k1j_1 = keyDescriptor;
    this.l1j_1 = valueDescriptor;
    this.m1j_1 = 2;
  }
  protoOf(MapLikeDescriptor).a1f = function () {
    return this.j1j_1;
  };
  protoOf(MapLikeDescriptor).e1f = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).c1f = function () {
    return this.m1j_1;
  };
  protoOf(MapLikeDescriptor).i1f = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).h1f = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).j1f = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.a1f() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).f1f = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.a1f() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).g1f = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.a1f() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.k1j_1;
        break;
      case 1:
        tmp = this.l1j_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.a1f() === other.a1f()))
      return false;
    if (!equals(this.k1j_1, other.k1j_1))
      return false;
    if (!equals(this.l1j_1, other.l1j_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.a1f());
    result = imul(31, result) + hashCode(this.k1j_1) | 0;
    result = imul(31, result) + hashCode(this.l1j_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.a1f() + '(' + toString(this.k1j_1) + ', ' + toString(this.l1j_1) + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.r1j_1 = primitive.a1f() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).a1f = function () {
    return this.r1j_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.t1j_1 = new ArrayListClassDesc(element.t1d());
  }
  protoOf(ArrayListSerializer).t1d = function () {
    return this.t1j_1;
  };
  protoOf(ArrayListSerializer).u1j = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ArrayListSerializer).v1j = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(ArrayListSerializer).w1j = function (_this__u8e3s4) {
    return this.v1j(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).x1j = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).y1j = function (_this__u8e3s4) {
    return this.x1j(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).z1j = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).a1k = function (_this__u8e3s4) {
    return this.z1j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).b1k = function (_this__u8e3s4, size) {
    return _this__u8e3s4.z4(size);
  };
  protoOf(ArrayListSerializer).c1k = function (_this__u8e3s4, size) {
    return this.b1k(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).d1k = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.u1(index, element);
  };
  protoOf(ArrayListSerializer).e1k = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.d1k(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.p1k_1 = new HashSetClassDesc(eSerializer.t1d());
  }
  protoOf(HashSetSerializer).t1d = function () {
    return this.p1k_1;
  };
  protoOf(HashSetSerializer).u1j = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).q1k = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(HashSetSerializer).w1j = function (_this__u8e3s4) {
    return this.q1k(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).r1k = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).y1j = function (_this__u8e3s4) {
    return this.r1k(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).s1k = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).a1k = function (_this__u8e3s4) {
    return this.s1k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).t1k = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).c1k = function (_this__u8e3s4, size) {
    return this.t1k(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).u1k = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.e(element);
  };
  protoOf(HashSetSerializer).e1k = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.u1k(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.w1k_1 = new LinkedHashSetClassDesc(eSerializer.t1d());
  }
  protoOf(LinkedHashSetSerializer).t1d = function () {
    return this.w1k_1;
  };
  protoOf(LinkedHashSetSerializer).u1j = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).x1k = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(LinkedHashSetSerializer).w1j = function (_this__u8e3s4) {
    return this.x1k(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).y1k = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).y1j = function (_this__u8e3s4) {
    return this.y1k(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).s1k = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).a1k = function (_this__u8e3s4) {
    return this.s1k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).z1k = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).c1k = function (_this__u8e3s4, size) {
    return this.z1k(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).a1l = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.e(element);
  };
  protoOf(LinkedHashSetSerializer).e1k = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.a1l(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.d1l_1 = new HashMapClassDesc(kSerializer.t1d(), vSerializer.t1d());
  }
  protoOf(HashMapSerializer).t1d = function () {
    return this.d1l_1;
  };
  protoOf(HashMapSerializer).e1l = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(HashMapSerializer).f1l = function (_this__u8e3s4) {
    return this.e1l((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).g1l = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.t().g();
  };
  protoOf(HashMapSerializer).h1l = function (_this__u8e3s4) {
    return this.g1l((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).u1j = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).i1l = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.j(), 2);
  };
  protoOf(HashMapSerializer).w1j = function (_this__u8e3s4) {
    return this.i1l(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).j1l = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).y1j = function (_this__u8e3s4) {
    return this.j1l(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).k1l = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).a1k = function (_this__u8e3s4) {
    return this.k1l((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).l1l = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).c1k = function (_this__u8e3s4, size) {
    return this.l1l(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.s1l_1 = new LinkedHashMapClassDesc(kSerializer.t1d(), vSerializer.t1d());
  }
  protoOf(LinkedHashMapSerializer).t1d = function () {
    return this.s1l_1;
  };
  protoOf(LinkedHashMapSerializer).e1l = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(LinkedHashMapSerializer).f1l = function (_this__u8e3s4) {
    return this.e1l((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).g1l = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.t().g();
  };
  protoOf(LinkedHashMapSerializer).h1l = function (_this__u8e3s4) {
    return this.g1l((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).u1j = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).t1l = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.j(), 2);
  };
  protoOf(LinkedHashMapSerializer).w1j = function (_this__u8e3s4) {
    return this.t1l(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).u1l = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).y1j = function (_this__u8e3s4) {
    return this.u1l(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).k1l = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).a1k = function (_this__u8e3s4) {
    return this.k1l((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).v1l = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).c1k = function (_this__u8e3s4, size) {
    return this.v1l(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.x1l_1 = kClass;
    this.y1l_1 = new ArrayClassDesc(eSerializer.t1d());
  }
  protoOf(ReferenceArraySerializer).t1d = function () {
    return this.y1l_1;
  };
  protoOf(ReferenceArraySerializer).z1l = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).f1l = function (_this__u8e3s4) {
    return this.z1l((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).a1m = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).h1l = function (_this__u8e3s4) {
    return this.a1m((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).u1j = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ReferenceArraySerializer).b1m = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(ReferenceArraySerializer).w1j = function (_this__u8e3s4) {
    return this.b1m(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).c1m = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.x1l_1);
  };
  protoOf(ReferenceArraySerializer).y1j = function (_this__u8e3s4) {
    return this.c1m(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).d1m = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).a1k = function (_this__u8e3s4) {
    return this.d1m((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).e1m = function (_this__u8e3s4, size) {
    return _this__u8e3s4.z4(size);
  };
  protoOf(ReferenceArraySerializer).c1k = function (_this__u8e3s4, size) {
    return this.e1m(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).f1m = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.u1(index, element);
  };
  protoOf(ReferenceArraySerializer).e1k = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.f1m(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).g1k = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(CollectionSerializer).f1l = function (_this__u8e3s4) {
    return this.g1k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).h1k = function (_this__u8e3s4) {
    return _this__u8e3s4.g();
  };
  protoOf(CollectionSerializer).h1l = function (_this__u8e3s4) {
    return this.h1k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.m1l_1 = keySerializer;
    this.n1l_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).o1l = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.b1_1;
    var last = progression.c1_1;
    var step_0 = progression.d1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.p1l(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).k1k = function (decoder, builder, startIndex, size) {
    return this.o1l(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).p1l = function (decoder, index, builder, checkIndex) {
    var key = decoder.k1h(this.t1d(), index, this.m1l_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.n1h(this.t1d());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.w1(key)) {
      var tmp_2 = this.n1l_1.t1d().e1f();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.j1h(this.t1d(), vIndex, this.n1l_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.k1h(this.t1d(), vIndex, this.n1l_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.b2(key, value);
  };
  protoOf(MapLikeSerializer).l1k = function (decoder, index, builder, checkIndex) {
    return this.p1l(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).j1k = function (encoder, value) {
    var size = this.f1l(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.t1d();
    var composite = encoder.s1i(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.h1l(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = iterator;
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.u();
      // Inline function 'kotlin.collections.component2' call
      var v = element.v();
      var tmp = this.t1d();
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      composite.n1i(tmp, tmp0, this.m1l_1, k);
      var tmp_0 = this.t1d();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      composite.n1i(tmp_0, tmp1, this.n1l_1, v);
    }
    composite.y1g(descriptor);
  };
  protoOf(MapLikeSerializer).u1d = function (encoder, value) {
    return this.j1k(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.i1k_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).j1k = function (encoder, value) {
    var size = this.f1l(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.t1d();
    var composite = encoder.s1i(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.h1l(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.n1i(this.t1d(), index, this.i1k_1, iterator.i());
      }
       while (inductionVariable < size);
    composite.y1g(descriptor);
  };
  protoOf(CollectionLikeSerializer).u1d = function (encoder, value) {
    return this.j1k(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(CollectionLikeSerializer).k1k = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.l1k(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).l1k = function (decoder, index, builder, checkIndex) {
    this.e1k(builder, index, decoder.k1h(this.t1d(), index, this.i1k_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.o1h($this.t1d());
    $this.c1k(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).n1k = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.a1k(previous);
    var builder = tmp1_elvis_lhs == null ? this.u1j() : tmp1_elvis_lhs;
    var startIndex = this.w1j(builder);
    var compositeDecoder = decoder.x1g(this.t1d());
    if (compositeDecoder.m1h()) {
      this.k1k(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.n1h(this.t1d());
        if (index === -1)
          break $l$loop;
        this.m1k(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.y1g(this.t1d());
    return this.y1j(builder);
  };
  protoOf(AbstractCollectionSerializer).v1d = function (decoder) {
    return this.n1k(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).m1k = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.l1k(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.l1k.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.h1m_1 = new PrimitiveArrayDescriptor(primitiveSerializer.t1d());
  }
  protoOf(PrimitiveArraySerializer).t1d = function () {
    return this.h1m_1;
  };
  protoOf(PrimitiveArraySerializer).i1m = function (_this__u8e3s4) {
    return _this__u8e3s4.j1m();
  };
  protoOf(PrimitiveArraySerializer).w1j = function (_this__u8e3s4) {
    return this.i1m(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).k1m = function (_this__u8e3s4) {
    return _this__u8e3s4.l1m();
  };
  protoOf(PrimitiveArraySerializer).y1j = function (_this__u8e3s4) {
    return this.k1m(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).m1m = function (_this__u8e3s4, size) {
    return _this__u8e3s4.n1m(size);
  };
  protoOf(PrimitiveArraySerializer).c1k = function (_this__u8e3s4, size) {
    return this.m1m(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).o1m = function (_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).h1l = function (_this__u8e3s4) {
    return this.o1m((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).p1m = function (_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).e1k = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.p1m(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).u1j = function () {
    return this.a1k(this.q1m());
  };
  protoOf(PrimitiveArraySerializer).t1m = function (encoder, value) {
    var size = this.f1l(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.h1m_1;
    var composite = encoder.s1i(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.s1m(composite, value, size);
    composite.y1g(descriptor);
  };
  protoOf(PrimitiveArraySerializer).u1d = function (encoder, value) {
    return this.t1m(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).j1k = function (encoder, value) {
    return this.t1m(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).v1d = function (decoder) {
    return this.n1k(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).u1m = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.j1m() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.n1m(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.n1m.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion() {
    Companion_instance_0 = this;
    this.v1m_1 = longArray(0);
  }
  var Companion_instance_0;
  function Companion_getInstance_6() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    var elementsInLastSlot = elementsCount & 63;
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).u2(elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    var offsetInSlot = index & 63;
    $this.z1m_1[slot] = $this.z1m_1[slot].y2((new Long(1, 0)).u2(offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.z1m_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var slotOffset = imul(slot + 1 | 0, 64);
        var slotMarks = $this.z1m_1[slot];
        while (!slotMarks.equals(new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(slotMarks.t2());
          slotMarks = slotMarks.y2((new Long(1, 0)).u2(indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.x1m_1($this.w1m_1, index)) {
            $this.z1m_1[slot] = slotMarks;
            return index;
          }
        }
        $this.z1m_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_6();
    this.w1m_1 = descriptor;
    this.x1m_1 = readIfAbsent;
    var elementsCount = this.w1m_1.c1f();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).u2(elementsCount);
      }
      tmp.y1m_1 = tmp_0;
      this.z1m_1 = Companion_getInstance_6().v1m_1;
    } else {
      this.y1m_1 = new Long(0, 0);
      this.z1m_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).a1n = function (index) {
    if (index < 64) {
      this.y1m_1 = this.y1m_1.y2((new Long(1, 0)).u2(index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).b1n = function () {
    var elementsCount = this.w1m_1.c1f();
    while (!this.y1m_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.y1m_1.t2());
      this.y1m_1 = this.y1m_1.y2((new Long(1, 0)).u2(index));
      if (this.x1m_1(this.w1m_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
    var descriptor = new EnumDescriptor(serialName, values.length);
    if (classAnnotations == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = classAnnotations.length;
      while (inductionVariable < last) {
        var element = classAnnotations[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.internal.createAnnotatedEnumSerializer.<anonymous>' call
        descriptor.o1n(element);
      }
    }
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var inductionVariable_0 = 0;
    var last_0 = values.length;
    while (inductionVariable_0 < last_0) {
      var item = values[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlinx.serialization.internal.createAnnotatedEnumSerializer.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp0_elvis_lhs = getOrNull(names, tmp1);
      var elementName = tmp0_elvis_lhs == null ? item.e2_1 : tmp0_elvis_lhs;
      descriptor.p1n(elementName);
      var tmp1_safe_receiver = getOrNull(entryAnnotations, tmp1);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = tmp1_safe_receiver.length;
        while (inductionVariable_1 < last_1) {
          var element_0 = tmp1_safe_receiver[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'kotlinx.serialization.internal.createAnnotatedEnumSerializer.<anonymous>.<anonymous>' call
          descriptor.q1n(element_0);
        }
      }
    }
    return EnumSerializer_init_$Create$(serialName, values, descriptor);
  }
  function _get_elementDescriptors__y23q9p($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.e1o_1;
    elementDescriptors$factory();
    return this_0.v();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.i1f(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.d1o_1 = ENUM_getInstance();
    var tmp = this;
    tmp.e1o_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).e1f = function () {
    return this.d1o_1;
  };
  protoOf(EnumDescriptor).g1f = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.e1f() === ENUM_getInstance()))
      return false;
    if (!(this.a1f() === other.a1f()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString(get_elementNames(this), ', ', this.a1f() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.a1f());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = get_elementNames(this).g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function EnumSerializer_init_$Init$(serialName, values, descriptor, $this) {
    EnumSerializer.call($this, serialName, values);
    $this.i1o_1 = descriptor;
    return $this;
  }
  function EnumSerializer_init_$Create$(serialName, values, descriptor) {
    return EnumSerializer_init_$Init$(serialName, values, descriptor, objectCreate(protoOf(EnumSerializer)));
  }
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.h1o_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.h1o_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
      d.p1n(element.e2_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.i1o_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer(serialName, values) {
    this.h1o_1 = values;
    this.i1o_1 = null;
    var tmp = this;
    tmp.j1o_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).t1d = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j1o_1;
    descriptor$factory_0();
    return this_0.v();
  };
  protoOf(EnumSerializer).k1o = function (encoder, value) {
    var index = indexOf(this.h1o_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0(toString(value) + ' is not a valid enum ' + this.t1d().a1f() + ', ' + ('must be one of ' + contentToString(this.h1o_1)));
    }
    encoder.b1i(this.t1d(), index);
  };
  protoOf(EnumSerializer).u1d = function (encoder, value) {
    return this.k1o(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).v1d = function (decoder) {
    var index = decoder.t1g(this.t1d());
    if (!(0 <= index ? index <= (this.h1o_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.t1d().a1f() + ' enum values, ' + ('values size is ' + this.h1o_1.length));
    }
    return this.h1o_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.t1d().a1f() + '>';
  };
  function elementDescriptors$factory() {
    return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
      return _get_elementDescriptors__y23q9p(receiver);
    }, null);
  }
  function descriptor$factory_0() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.t1d();
    }, null);
  }
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.x1o_1 = true;
  }
  protoOf(InlineClassDescriptor).d1f = function () {
    return this.x1o_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.a1f() === other.a1f())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.x1o_1 && contentEquals(this.f1o(), other.f1o()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.c1f() === other.c1f())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.c1f();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.g1f(index).a1f() === other.g1f(index).a1f())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.g1f(index).e1f(), other.g1f(index).e1f())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.y1o_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).z1o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.y1o_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).t1d = function () {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).u1d = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).v1d = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.b1p_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).o1e = function () {
    return this.b1p_1;
  };
  protoOf(NoOpEncoder).q1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).r1h = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).s1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).t1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).u1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).v1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).w1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).x1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).y1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).z1h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).a1i = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).b1i = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.c1p_1 = OBJECT_getInstance();
    this.d1p_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).e1f = function () {
    return this.c1p_1;
  };
  protoOf(NothingSerialDescriptor).a1f = function () {
    return this.d1p_1;
  };
  protoOf(NothingSerialDescriptor).c1f = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).i1f = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).h1f = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).j1f = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).g1f = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).f1f = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.d1p_1) + imul(31, this.c1p_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.e1p_1 = serializer;
    this.f1p_1 = new SerialDescriptorForNullable(this.e1p_1.t1d());
  }
  protoOf(NullableSerializer).t1d = function () {
    return this.f1p_1;
  };
  protoOf(NullableSerializer).g1p = function (encoder, value) {
    if (!(value == null)) {
      encoder.r1i();
      encoder.o1i(this.e1p_1, value);
    } else {
      encoder.r1h();
    }
  };
  protoOf(NullableSerializer).u1d = function (encoder, value) {
    return this.g1p(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(NullableSerializer).v1d = function (decoder) {
    return decoder.i1g() ? decoder.w1g(this.e1p_1) : decoder.j1g();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.e1p_1, other.e1p_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.e1p_1);
  };
  function SerialDescriptorForNullable(original) {
    this.k1f_1 = original;
    this.l1f_1 = this.k1f_1.a1f() + '?';
    this.m1f_1 = cachedSerialNames(this.k1f_1);
  }
  protoOf(SerialDescriptorForNullable).b1f = function () {
    return this.k1f_1.b1f();
  };
  protoOf(SerialDescriptorForNullable).c1f = function () {
    return this.k1f_1.c1f();
  };
  protoOf(SerialDescriptorForNullable).d1f = function () {
    return this.k1f_1.d1f();
  };
  protoOf(SerialDescriptorForNullable).e1f = function () {
    return this.k1f_1.e1f();
  };
  protoOf(SerialDescriptorForNullable).f1f = function (index) {
    return this.k1f_1.f1f(index);
  };
  protoOf(SerialDescriptorForNullable).g1f = function (index) {
    return this.k1f_1.g1f(index);
  };
  protoOf(SerialDescriptorForNullable).h1f = function (name) {
    return this.k1f_1.h1f(name);
  };
  protoOf(SerialDescriptorForNullable).i1f = function (index) {
    return this.k1f_1.i1f(index);
  };
  protoOf(SerialDescriptorForNullable).j1f = function (index) {
    return this.k1f_1.j1f(index);
  };
  protoOf(SerialDescriptorForNullable).a1f = function () {
    return this.l1f_1;
  };
  protoOf(SerialDescriptorForNullable).g1g = function () {
    return this.m1f_1;
  };
  protoOf(SerialDescriptorForNullable).w1e = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.k1f_1, other.k1f_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return toString(this.k1f_1) + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.k1f_1), 31);
  };
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.y1d_1 = this$0.i1p_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.h1p_1 = objectInstance;
    this.i1p_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j1p_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).t1d = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j1p_1;
    descriptor$factory_1();
    return this_0.v();
  };
  protoOf(ObjectSerializer).j1e = function (encoder, value) {
    encoder.x1g(this.t1d()).y1g(this.t1d());
  };
  protoOf(ObjectSerializer).u1d = function (encoder, value) {
    return this.j1e(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).v1d = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.t1d();
    var composite = decoder.x1g(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.m1h()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.n1h(this.t1d());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
    var result = tmp$ret$0;
    composite.y1g(descriptor);
    return this.h1p_1;
  };
  function descriptor$factory_1() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.t1d();
    }, null);
  }
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.g1g();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.c1f());
    var inductionVariable = 0;
    var last = _this__u8e3s4.c1f();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.i1f(i);
        result.e(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.da();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        var message = 'Captured type parameter ' + toString_0(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported as ' + toString_0(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString_0(t));
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        var message_0 = 'Only KClass supported as classifier, got ' + toString_0(t);
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.p9();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(_this__u8e3s4 == null || _this__u8e3s4.o())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function serializerNotRegistered(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.i1f(i);
          missingFields.e(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.a1f());
  }
  function _get_childSerializers__7vnyfa($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.l1n_1;
    childSerializers$factory();
    return this_0.v();
  }
  function _get__hashCode__tgwhef_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.n1n_1;
    _hashCode$factory_0();
    return this_0.v();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.g1n_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.g1n_1[i];
        indices.b2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.d1n_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1o();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.d1n_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1p();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item.t1d();
          destination.e(tmp$ret$0);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.f1o());
    };
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.i1f(i) + ': ' + this$0.g1f(i).a1f();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.c1n_1 = serialName;
    this.d1n_1 = generatedSerializer;
    this.e1n_1 = elementsCount;
    this.f1n_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.e1n_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.g1n_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.e1n_1;
    tmp_3.h1n_1 = fillArrayVal(Array(size), null);
    this.i1n_1 = null;
    this.j1n_1 = booleanArray(this.e1n_1);
    this.k1n_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.l1n_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.m1n_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.n1n_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).a1f = function () {
    return this.c1n_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).c1f = function () {
    return this.e1n_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).e1f = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).b1f = function () {
    var tmp0_elvis_lhs = this.i1n_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).g1g = function () {
    return this.k1n_1.z1();
  };
  protoOf(PluginGeneratedSerialDescriptor).f1o = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m1n_1;
    typeParameterDescriptors$factory();
    return this_0.v();
  };
  protoOf(PluginGeneratedSerialDescriptor).g1o = function (name, isOptional) {
    this.f1n_1 = this.f1n_1 + 1 | 0;
    this.g1n_1[this.f1n_1] = name;
    this.j1n_1[this.f1n_1] = isOptional;
    this.h1n_1[this.f1n_1] = null;
    if (this.f1n_1 === (this.e1n_1 - 1 | 0)) {
      this.k1n_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).p1n = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.g1o(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.g1o.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).q1n = function (annotation) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.pushAnnotation.<anonymous>' call
    var it = this.h1n_1[this.f1n_1];
    var tmp;
    if (it == null) {
      var result = ArrayList_init_$Create$(1);
      this.h1n_1[this.f1n_1] = result;
      tmp = result;
    } else {
      tmp = it;
    }
    var list = tmp;
    list.e(annotation);
  };
  protoOf(PluginGeneratedSerialDescriptor).o1n = function (a) {
    if (this.i1n_1 == null) {
      this.i1n_1 = ArrayList_init_$Create$(1);
    }
    ensureNotNull(this.i1n_1).e(a);
  };
  protoOf(PluginGeneratedSerialDescriptor).g1f = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).t1d();
  };
  protoOf(PluginGeneratedSerialDescriptor).j1f = function (index) {
    return getChecked_0(this.j1n_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).f1f = function (index) {
    var tmp0_elvis_lhs = getChecked(this.h1n_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).i1f = function (index) {
    return getChecked(this.g1n_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).h1f = function (name) {
    var tmp0_elvis_lhs = this.k1n_1.y1(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.a1f() === other.a1f())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.f1o(), other.f1o())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.c1f() === other.c1f())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.c1f();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.g1f(index).a1f() === other.g1f(index).a1f())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.g1f(index).e1f(), other.g1f(index).e1f())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.e1n_1);
    var tmp_0 = this.a1f() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.a1f());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = elementDescriptors.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver = element.a1f();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var tmp0_iterator_0 = elementDescriptors.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver_0 = element_0.e1f();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers__7vnyfa(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return receiver.f1o();
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef_0(receiver);
    }, null);
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_2(Companion_getInstance_0()));
  }
  protoOf(CharArraySerializer_0).n1p = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.n1p((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).o1p = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.o1p((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).q1m = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).p1p = function (decoder, index, builder, checkIndex) {
    builder.s1p(decoder.g1h(this.h1m_1, index));
  };
  protoOf(CharArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.p1p(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.p1p(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).t1p = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.k1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).s1m = function (encoder, content, size) {
    return this.t1p(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).w1p = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.w1p((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).x1p = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.x1p((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).q1m = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).y1p = function (decoder, index, builder, checkIndex) {
    builder.b1q(decoder.f1h(this.h1m_1, index));
  };
  protoOf(DoubleArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.y1p(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.y1p(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).c1q = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.j1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).s1m = function (encoder, content, size) {
    return this.c1q(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).f1q = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.f1q((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).g1q = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.g1q((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).q1m = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).h1q = function (decoder, index, builder, checkIndex) {
    builder.k1q(decoder.e1h(this.h1m_1, index));
  };
  protoOf(FloatArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.h1q(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.h1q(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).l1q = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.i1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).s1m = function (encoder, content, size) {
    return this.l1q(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_1()));
  }
  protoOf(LongArraySerializer_0).o1q = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.o1q((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).p1q = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.p1q((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).q1m = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).q1q = function (decoder, index, builder, checkIndex) {
    builder.t1q(decoder.d1h(this.h1m_1, index));
  };
  protoOf(LongArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.q1q(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.q1q(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).u1q = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.h1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).s1m = function (encoder, content, size) {
    return this.u1q(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_2()));
  }
  protoOf(ULongArraySerializer_0).x1q = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.x1q(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.ni_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).y1q = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.y1q(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.ni_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).z1q = function () {
    return _ULongArray___init__impl__twm1l3(0);
  };
  protoOf(ULongArraySerializer_0).q1m = function () {
    return new ULongArray(this.z1q());
  };
  protoOf(ULongArraySerializer_0).a1r = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.i1h(this.h1m_1, index).o1g();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.d1r(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.a1r(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.a1r(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).e1r = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.m1i(this.h1m_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.w1h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).s1m = function (encoder, content, size) {
    return this.e1r(encoder, content instanceof ULongArray ? content.ni_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).h1r = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.h1r((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).i1r = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.i1r((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).q1m = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).j1r = function (decoder, index, builder, checkIndex) {
    builder.m1r(decoder.c1h(this.h1m_1, index));
  };
  protoOf(IntArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.j1r(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.j1r(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).n1r = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.g1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).s1m = function (encoder, content, size) {
    return this.n1r(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(Companion_getInstance_3()));
  }
  protoOf(UIntArraySerializer_0).q1r = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.q1r(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.bi_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).r1r = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.r1r(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.bi_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).s1r = function () {
    return _UIntArray___init__impl__ghjpc6(0);
  };
  protoOf(UIntArraySerializer_0).q1m = function () {
    return new UIntArray(this.s1r());
  };
  protoOf(UIntArraySerializer_0).t1r = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.i1h(this.h1m_1, index).n1g();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.w1r(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.t1r(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.t1r(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).x1r = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.m1i(this.h1m_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.v1h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).s1m = function (encoder, content, size) {
    return this.x1r(encoder, content instanceof UIntArray ? content.bi_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).a1s = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.a1s((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).b1s = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.b1s((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).q1m = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).c1s = function (decoder, index, builder, checkIndex) {
    builder.f1s(decoder.b1h(this.h1m_1, index));
  };
  protoOf(ShortArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.c1s(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.c1s(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).g1s = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.f1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).s1m = function (encoder, content, size) {
    return this.g1s(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(Companion_getInstance_4()));
  }
  protoOf(UShortArraySerializer_0).j1s = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.j1s(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.zi_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).k1s = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.k1s(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.zi_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).l1s = function () {
    return _UShortArray___init__impl__9b26ef(0);
  };
  protoOf(UShortArraySerializer_0).q1m = function () {
    return new UShortArray(this.l1s());
  };
  protoOf(UShortArraySerializer_0).m1s = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.i1h(this.h1m_1, index).m1g();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.p1s(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.m1s(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.m1s(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).q1s = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.m1i(this.h1m_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.u1h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).s1m = function (encoder, content, size) {
    return this.q1s(encoder, content instanceof UShortArray ? content.zi_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).t1s = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.t1s((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).u1s = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.u1s((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).q1m = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).v1s = function (decoder, index, builder, checkIndex) {
    builder.y1s(decoder.a1h(this.h1m_1, index));
  };
  protoOf(ByteArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.v1s(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.v1s(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).z1s = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.e1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).s1m = function (encoder, content, size) {
    return this.z1s(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(Companion_getInstance_5()));
  }
  protoOf(UByteArraySerializer_0).c1t = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.c1t(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ph_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).d1t = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.d1t(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ph_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).e1t = function () {
    return _UByteArray___init__impl__ip4y9n(0);
  };
  protoOf(UByteArraySerializer_0).q1m = function () {
    return new UByteArray(this.e1t());
  };
  protoOf(UByteArraySerializer_0).f1t = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.i1h(this.h1m_1, index).l1g();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.i1t(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.f1t(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.f1t(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).j1t = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.m1i(this.h1m_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.t1h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).s1m = function (encoder, content, size) {
    return this.j1t(encoder, content instanceof UByteArray ? content.ph_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_13(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).m1t = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).f1l = function (_this__u8e3s4) {
    return this.m1t((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).n1t = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).a1k = function (_this__u8e3s4) {
    return this.n1t((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).q1m = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).o1t = function (decoder, index, builder, checkIndex) {
    builder.r1t(decoder.z1g(this.h1m_1, index));
  };
  protoOf(BooleanArraySerializer_0).l1k = function (decoder, index, builder, checkIndex) {
    return this.o1t(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).r1m = function (decoder, index, builder, checkIndex) {
    return this.o1t(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).s1t = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.d1i(this.h1m_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).s1m = function (encoder, content, size) {
    return this.s1t(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.q1p_1 = bufferWithData;
    this.r1p_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(CharArrayBuilder).j1m = function () {
    return this.r1p_1;
  };
  protoOf(CharArrayBuilder).n1m = function (requiredCapacity) {
    if (this.q1p_1.length < requiredCapacity)
      this.q1p_1 = copyOf(this.q1p_1, coerceAtLeast(requiredCapacity, imul(this.q1p_1.length, 2)));
  };
  protoOf(CharArrayBuilder).s1p = function (c) {
    this.u1m();
    var tmp = this.q1p_1;
    var tmp1 = this.r1p_1;
    this.r1p_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(CharArrayBuilder).l1m = function () {
    return copyOf(this.q1p_1, this.r1p_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.z1p_1 = bufferWithData;
    this.a1q_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(DoubleArrayBuilder).j1m = function () {
    return this.a1q_1;
  };
  protoOf(DoubleArrayBuilder).n1m = function (requiredCapacity) {
    if (this.z1p_1.length < requiredCapacity)
      this.z1p_1 = copyOf_0(this.z1p_1, coerceAtLeast(requiredCapacity, imul(this.z1p_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).b1q = function (c) {
    this.u1m();
    var tmp = this.z1p_1;
    var tmp1 = this.a1q_1;
    this.a1q_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(DoubleArrayBuilder).l1m = function () {
    return copyOf_0(this.z1p_1, this.a1q_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.i1q_1 = bufferWithData;
    this.j1q_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(FloatArrayBuilder).j1m = function () {
    return this.j1q_1;
  };
  protoOf(FloatArrayBuilder).n1m = function (requiredCapacity) {
    if (this.i1q_1.length < requiredCapacity)
      this.i1q_1 = copyOf_1(this.i1q_1, coerceAtLeast(requiredCapacity, imul(this.i1q_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).k1q = function (c) {
    this.u1m();
    var tmp = this.i1q_1;
    var tmp1 = this.j1q_1;
    this.j1q_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(FloatArrayBuilder).l1m = function () {
    return copyOf_1(this.i1q_1, this.j1q_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.r1q_1 = bufferWithData;
    this.s1q_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(LongArrayBuilder).j1m = function () {
    return this.s1q_1;
  };
  protoOf(LongArrayBuilder).n1m = function (requiredCapacity) {
    if (this.r1q_1.length < requiredCapacity)
      this.r1q_1 = copyOf_2(this.r1q_1, coerceAtLeast(requiredCapacity, imul(this.r1q_1.length, 2)));
  };
  protoOf(LongArrayBuilder).t1q = function (c) {
    this.u1m();
    var tmp = this.r1q_1;
    var tmp1 = this.s1q_1;
    this.s1q_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(LongArrayBuilder).l1m = function () {
    return copyOf_2(this.r1q_1, this.s1q_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.b1r_1 = bufferWithData;
    this.c1r_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.n1m(10);
  }
  protoOf(ULongArrayBuilder).j1m = function () {
    return this.c1r_1;
  };
  protoOf(ULongArrayBuilder).n1m = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.b1r_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.b1r_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.b1r_1), 2));
      tmp.b1r_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).d1r = function (c) {
    this.u1m();
    var tmp = this.b1r_1;
    var tmp1 = this.c1r_1;
    this.c1r_1 = tmp1 + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, tmp1, c);
  };
  protoOf(ULongArrayBuilder).t1t = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.b1r_1;
    var newSize = this.c1r_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
  };
  protoOf(ULongArrayBuilder).l1m = function () {
    return new ULongArray(this.t1t());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.k1r_1 = bufferWithData;
    this.l1r_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(IntArrayBuilder).j1m = function () {
    return this.l1r_1;
  };
  protoOf(IntArrayBuilder).n1m = function (requiredCapacity) {
    if (this.k1r_1.length < requiredCapacity)
      this.k1r_1 = copyOf_3(this.k1r_1, coerceAtLeast(requiredCapacity, imul(this.k1r_1.length, 2)));
  };
  protoOf(IntArrayBuilder).m1r = function (c) {
    this.u1m();
    var tmp = this.k1r_1;
    var tmp1 = this.l1r_1;
    this.l1r_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(IntArrayBuilder).l1m = function () {
    return copyOf_3(this.k1r_1, this.l1r_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.u1r_1 = bufferWithData;
    this.v1r_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.n1m(10);
  }
  protoOf(UIntArrayBuilder).j1m = function () {
    return this.v1r_1;
  };
  protoOf(UIntArrayBuilder).n1m = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.u1r_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.u1r_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.u1r_1), 2));
      tmp.u1r_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).w1r = function (c) {
    this.u1m();
    var tmp = this.u1r_1;
    var tmp1 = this.v1r_1;
    this.v1r_1 = tmp1 + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
  };
  protoOf(UIntArrayBuilder).u1t = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.u1r_1;
    var newSize = this.v1r_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
  };
  protoOf(UIntArrayBuilder).l1m = function () {
    return new UIntArray(this.u1t());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.d1s_1 = bufferWithData;
    this.e1s_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(ShortArrayBuilder).j1m = function () {
    return this.e1s_1;
  };
  protoOf(ShortArrayBuilder).n1m = function (requiredCapacity) {
    if (this.d1s_1.length < requiredCapacity)
      this.d1s_1 = copyOf_4(this.d1s_1, coerceAtLeast(requiredCapacity, imul(this.d1s_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).f1s = function (c) {
    this.u1m();
    var tmp = this.d1s_1;
    var tmp1 = this.e1s_1;
    this.e1s_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ShortArrayBuilder).l1m = function () {
    return copyOf_4(this.d1s_1, this.e1s_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.n1s_1 = bufferWithData;
    this.o1s_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.n1m(10);
  }
  protoOf(UShortArrayBuilder).j1m = function () {
    return this.o1s_1;
  };
  protoOf(UShortArrayBuilder).n1m = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.n1s_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.n1s_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.n1s_1), 2));
      tmp.n1s_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).p1s = function (c) {
    this.u1m();
    var tmp = this.n1s_1;
    var tmp1 = this.o1s_1;
    this.o1s_1 = tmp1 + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, tmp1, c);
  };
  protoOf(UShortArrayBuilder).v1t = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.n1s_1;
    var newSize = this.o1s_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
  };
  protoOf(UShortArrayBuilder).l1m = function () {
    return new UShortArray(this.v1t());
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.w1s_1 = bufferWithData;
    this.x1s_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(ByteArrayBuilder).j1m = function () {
    return this.x1s_1;
  };
  protoOf(ByteArrayBuilder).n1m = function (requiredCapacity) {
    if (this.w1s_1.length < requiredCapacity)
      this.w1s_1 = copyOf_5(this.w1s_1, coerceAtLeast(requiredCapacity, imul(this.w1s_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).y1s = function (c) {
    this.u1m();
    var tmp = this.w1s_1;
    var tmp1 = this.x1s_1;
    this.x1s_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ByteArrayBuilder).l1m = function () {
    return copyOf_5(this.w1s_1, this.x1s_1);
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.g1t_1 = bufferWithData;
    this.h1t_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.n1m(10);
  }
  protoOf(UByteArrayBuilder).j1m = function () {
    return this.h1t_1;
  };
  protoOf(UByteArrayBuilder).n1m = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.g1t_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.g1t_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.g1t_1), 2));
      tmp.g1t_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).i1t = function (c) {
    this.u1m();
    var tmp = this.g1t_1;
    var tmp1 = this.h1t_1;
    this.h1t_1 = tmp1 + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, tmp1, c);
  };
  protoOf(UByteArrayBuilder).w1t = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.g1t_1;
    var newSize = this.h1t_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
  };
  protoOf(UByteArrayBuilder).l1m = function () {
    return new UByteArray(this.w1t());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.p1t_1 = bufferWithData;
    this.q1t_1 = bufferWithData.length;
    this.n1m(10);
  }
  protoOf(BooleanArrayBuilder).j1m = function () {
    return this.q1t_1;
  };
  protoOf(BooleanArrayBuilder).n1m = function (requiredCapacity) {
    if (this.p1t_1.length < requiredCapacity)
      this.p1t_1 = copyOf_6(this.p1t_1, coerceAtLeast(requiredCapacity, imul(this.p1t_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).r1t = function (c) {
    this.u1m();
    var tmp = this.p1t_1;
    var tmp1 = this.q1t_1;
    this.q1t_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(BooleanArrayBuilder).l1m = function () {
    return copyOf_6(this.p1t_1, this.q1t_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().y1(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function StringSerializer() {
    StringSerializer_instance = this;
    this.x1t_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).t1d = function () {
    return this.x1t_1;
  };
  protoOf(StringSerializer).y1t = function (encoder, value) {
    return encoder.a1i(value);
  };
  protoOf(StringSerializer).u1d = function (encoder, value) {
    return this.y1t(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).v1d = function (decoder) {
    return decoder.s1g();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.z1t_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).t1d = function () {
    return this.z1t_1;
  };
  protoOf(CharSerializer).a1u = function (encoder, value) {
    return encoder.z1h(value);
  };
  protoOf(CharSerializer).u1d = function (encoder, value) {
    return this.a1u(encoder, value instanceof Char ? value.f1_1 : THROW_CCE());
  };
  protoOf(CharSerializer).b1u = function (decoder) {
    return decoder.r1g();
  };
  protoOf(CharSerializer).v1d = function (decoder) {
    return new Char(this.b1u(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.c1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).t1d = function () {
    return this.c1u_1;
  };
  protoOf(DoubleSerializer).d1u = function (encoder, value) {
    return encoder.y1h(value);
  };
  protoOf(DoubleSerializer).u1d = function (encoder, value) {
    return this.d1u(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).v1d = function (decoder) {
    return decoder.q1g();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.e1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).t1d = function () {
    return this.e1u_1;
  };
  protoOf(FloatSerializer).f1u = function (encoder, value) {
    return encoder.x1h(value);
  };
  protoOf(FloatSerializer).u1d = function (encoder, value) {
    return this.f1u(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).v1d = function (decoder) {
    return decoder.p1g();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.g1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).t1d = function () {
    return this.g1u_1;
  };
  protoOf(LongSerializer).h1u = function (encoder, value) {
    return encoder.w1h(value);
  };
  protoOf(LongSerializer).u1d = function (encoder, value) {
    return this.h1u(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).v1d = function (decoder) {
    return decoder.o1g();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.i1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).t1d = function () {
    return this.i1u_1;
  };
  protoOf(IntSerializer).j1u = function (encoder, value) {
    return encoder.v1h(value);
  };
  protoOf(IntSerializer).u1d = function (encoder, value) {
    return this.j1u(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).v1d = function (decoder) {
    return decoder.n1g();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.k1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).t1d = function () {
    return this.k1u_1;
  };
  protoOf(ShortSerializer).l1u = function (encoder, value) {
    return encoder.u1h(value);
  };
  protoOf(ShortSerializer).u1d = function (encoder, value) {
    return this.l1u(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).v1d = function (decoder) {
    return decoder.m1g();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.m1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).t1d = function () {
    return this.m1u_1;
  };
  protoOf(ByteSerializer).n1u = function (encoder, value) {
    return encoder.t1h(value);
  };
  protoOf(ByteSerializer).u1d = function (encoder, value) {
    return this.n1u(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).v1d = function (decoder) {
    return decoder.l1g();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.o1u_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).t1d = function () {
    return this.o1u_1;
  };
  protoOf(BooleanSerializer).p1u = function (encoder, value) {
    return encoder.s1h(value);
  };
  protoOf(BooleanSerializer).u1d = function (encoder, value) {
    return this.p1u(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).v1d = function (decoder) {
    return decoder.k1g();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.q1u_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).t1d = function () {
    return this.q1u_1.t1d();
  };
  protoOf(UnitSerializer).r1u = function (decoder) {
    this.q1u_1.v1d(decoder);
  };
  protoOf(UnitSerializer).v1d = function (decoder) {
    this.r1u(decoder);
    return Unit_instance;
  };
  protoOf(UnitSerializer).s1u = function (encoder, value) {
    this.q1u_1.j1e(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).u1d = function (encoder, value) {
    return this.s1u(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.t1u_1 = serialName;
    this.u1u_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).a1f = function () {
    return this.t1u_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).e1f = function () {
    return this.u1u_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).c1f = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).i1f = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).h1f = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).j1f = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).g1f = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).f1f = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.t1u_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.t1u_1 === other.t1u_1 && equals(this.u1u_1, other.u1u_1))
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.t1u_1) + imul(31, this.u1u_1.hashCode()) | 0;
  };
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var keys = get_BUILTIN_SERIALIZERS().z1();
    var tmp0_iterator = keys.g();
    while (tmp0_iterator.h()) {
      var primitive = tmp0_iterator.i();
      var simpleName = capitalize(ensureNotNull(primitive.p9()));
      var qualifiedName = 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) || equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function capitalize(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(_this__u8e3s4) > 0) {
      // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
      var it = charSequenceGet(_this__u8e3s4, 0);
      var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString_1(it);
      var tmp_0 = toString(tmp$ret$1);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp_0 + _this__u8e3s4.substring(1);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance().qa(), serializer_1(StringCompanionObject_instance)), to(getKClass(Char), serializer_2(Companion_getInstance_0())), to(PrimitiveClasses_getInstance().ta(), CharArraySerializer()), to(PrimitiveClasses_getInstance().oa(), serializer_3(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().za(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().na(), serializer_4(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().ya(), FloatArraySerializer()), to(getKClass(Long), serializer_5(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().xa(), LongArraySerializer()), to(getKClass(ULong), serializer_6(Companion_getInstance_2())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().ma(), serializer_7(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().wa(), IntArraySerializer()), to(getKClass(UInt), serializer_8(Companion_getInstance_3())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().la(), serializer_9(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().va(), ShortArraySerializer()), to(getKClass(UShort), serializer_10(Companion_getInstance_4())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().ka(), serializer_11(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().ua(), ByteArraySerializer()), to(getKClass(UByte), serializer_12(Companion_getInstance_5())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().ja(), serializer_13(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().sa(), BooleanArraySerializer()), to(getKClass(Unit), serializer_14(Unit_instance)), to(PrimitiveClasses_getInstance().ia(), NothingSerializer()), to(getKClass(Duration), serializer_15(Companion_getInstance()))]);
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).x1u = function (_this__u8e3s4, index) {
    return this.z1u(this.y1u(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).z1u = function (nestedName) {
    var tmp0_elvis_lhs = this.c1v();
    return this.d1v(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).y1u = function (descriptor, index) {
    return descriptor.i1f(index);
  };
  protoOf(NamedValueDecoder).d1v = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function tagBlock($this, tag, block) {
    $this.r1v(tag);
    var r = block();
    if (!$this.b1v_1) {
      $this.s1v();
    }
    $this.b1v_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.v1g($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
      var this_0 = this$0;
      var isNullabilitySupported = $deserializer.t1d().w1e();
      var tmp;
      if (isNullabilitySupported || this_0.i1g()) {
        // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeNullableSerializableElement.<anonymous>.<anonymous>' call
        tmp = this$0.v1g($deserializer, $previousValue);
      } else {
        tmp = this_0.j1g();
      }
      return tmp;
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a1v_1 = ArrayList_init_$Create$_0();
    this.b1v_1 = false;
  }
  protoOf(TaggedDecoder).o1e = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).e1v = function (tag) {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).f1v = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).g1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).h1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).i1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).j1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).k1v = function (tag) {
    var tmp = this.e1v(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).l1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).m1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).n1v = function (tag) {
    var tmp = this.e1v(tag);
    return tmp instanceof Char ? tmp.f1_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).o1v = function (tag) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).p1v = function (tag, enumDescriptor) {
    var tmp = this.e1v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).q1v = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.r1v(tag);
    return this;
  };
  protoOf(TaggedDecoder).v1g = function (deserializer, previousValue) {
    return this.w1g(deserializer);
  };
  protoOf(TaggedDecoder).u1g = function (descriptor) {
    return this.q1v(this.s1v(), descriptor);
  };
  protoOf(TaggedDecoder).i1g = function () {
    var tmp0_elvis_lhs = this.c1v();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.f1v(currentTag);
  };
  protoOf(TaggedDecoder).j1g = function () {
    return null;
  };
  protoOf(TaggedDecoder).k1g = function () {
    return this.g1v(this.s1v());
  };
  protoOf(TaggedDecoder).l1g = function () {
    return this.h1v(this.s1v());
  };
  protoOf(TaggedDecoder).m1g = function () {
    return this.i1v(this.s1v());
  };
  protoOf(TaggedDecoder).n1g = function () {
    return this.j1v(this.s1v());
  };
  protoOf(TaggedDecoder).o1g = function () {
    return this.k1v(this.s1v());
  };
  protoOf(TaggedDecoder).p1g = function () {
    return this.l1v(this.s1v());
  };
  protoOf(TaggedDecoder).q1g = function () {
    return this.m1v(this.s1v());
  };
  protoOf(TaggedDecoder).r1g = function () {
    return this.n1v(this.s1v());
  };
  protoOf(TaggedDecoder).s1g = function () {
    return this.o1v(this.s1v());
  };
  protoOf(TaggedDecoder).t1g = function (enumDescriptor) {
    return this.p1v(this.s1v(), enumDescriptor);
  };
  protoOf(TaggedDecoder).x1g = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).y1g = function (descriptor) {
  };
  protoOf(TaggedDecoder).z1g = function (descriptor, index) {
    return this.g1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).a1h = function (descriptor, index) {
    return this.h1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).b1h = function (descriptor, index) {
    return this.i1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).c1h = function (descriptor, index) {
    return this.j1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).d1h = function (descriptor, index) {
    return this.k1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).e1h = function (descriptor, index) {
    return this.l1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).f1h = function (descriptor, index) {
    return this.m1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).g1h = function (descriptor, index) {
    return this.n1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).h1h = function (descriptor, index) {
    return this.o1v(this.x1u(descriptor, index));
  };
  protoOf(TaggedDecoder).i1h = function (descriptor, index) {
    return this.q1v(this.x1u(descriptor, index), descriptor.g1f(index));
  };
  protoOf(TaggedDecoder).j1h = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.x1u(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).l1h = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.x1u(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).c1v = function () {
    return lastOrNull(this.a1v_1);
  };
  protoOf(TaggedDecoder).r1v = function (name) {
    this.a1v_1.e(name);
  };
  protoOf(TaggedDecoder).s1v = function () {
    var r = this.a1v_1.v1(get_lastIndex_0(this.a1v_1));
    this.b1v_1 = true;
    return r;
  };
  function get_NULL() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL;
  }
  var NULL;
  function MapEntry(key, value) {
    this.t1v_1 = key;
    this.u1v_1 = value;
  }
  protoOf(MapEntry).u = function () {
    return this.t1v_1;
  };
  protoOf(MapEntry).v = function () {
    return this.u1v_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + toString_0(this.t1v_1) + ', value=' + toString_0(this.u1v_1) + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.t1v_1 == null ? 0 : hashCode(this.t1v_1);
    result = imul(result, 31) + (this.u1v_1 == null ? 0 : hashCode(this.u1v_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.t1v_1, tmp0_other_with_cast.t1v_1))
      return false;
    if (!equals(this.u1v_1, tmp0_other_with_cast.u1v_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.e1e('key', $keySerializer.t1d());
      $this$buildSerialDescriptor.e1e('value', $valueSerializer.t1d());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.x1v_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).t1d = function () {
    return this.x1v_1;
  };
  protoOf(MapEntrySerializer_0).y1v = function (_this__u8e3s4) {
    return _this__u8e3s4.u();
  };
  protoOf(MapEntrySerializer_0).z1v = function (_this__u8e3s4) {
    return this.y1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).a1w = function (_this__u8e3s4) {
    return _this__u8e3s4.v();
  };
  protoOf(MapEntrySerializer_0).b1w = function (_this__u8e3s4) {
    return this.a1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).c1w = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.e1e('first', $keySerializer.t1d());
      $this$buildClassSerialDescriptor.e1e('second', $valueSerializer.t1d());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.i1w_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).t1d = function () {
    return this.i1w_1;
  };
  protoOf(PairSerializer_0).j1w = function (_this__u8e3s4) {
    return _this__u8e3s4.td_1;
  };
  protoOf(PairSerializer_0).z1v = function (_this__u8e3s4) {
    return this.j1w(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).k1w = function (_this__u8e3s4) {
    return _this__u8e3s4.ud_1;
  };
  protoOf(PairSerializer_0).b1w = function (_this__u8e3s4) {
    return this.k1w(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).c1w = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.k1h($this.o1w_1, 0, $this.l1w_1);
    var b = composite.k1h($this.o1w_1, 1, $this.m1w_1);
    var c = composite.k1h($this.o1w_1, 2, $this.n1w_1);
    composite.y1g($this.o1w_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL();
    var b = get_NULL();
    var c = get_NULL();
    mainLoop: while (true) {
      var index = composite.n1h($this.o1w_1);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.k1h($this.o1w_1, 0, $this.l1w_1);
          break;
        case 1:
          b = composite.k1h($this.o1w_1, 1, $this.m1w_1);
          break;
        case 2:
          c = composite.k1h($this.o1w_1, 2, $this.n1w_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    composite.y1g($this.o1w_1);
    if (a === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.e1e('first', this$0.l1w_1.t1d());
      $this$buildClassSerialDescriptor.e1e('second', this$0.m1w_1.t1d());
      $this$buildClassSerialDescriptor.e1e('third', this$0.n1w_1.t1d());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.l1w_1 = aSerializer;
    this.m1w_1 = bSerializer;
    this.n1w_1 = cSerializer;
    var tmp = this;
    tmp.o1w_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).t1d = function () {
    return this.o1w_1;
  };
  protoOf(TripleSerializer_0).p1w = function (encoder, value) {
    var structuredEncoder = encoder.x1g(this.o1w_1);
    structuredEncoder.n1i(this.o1w_1, 0, this.l1w_1, value.dh_1);
    structuredEncoder.n1i(this.o1w_1, 1, this.m1w_1, value.eh_1);
    structuredEncoder.n1i(this.o1w_1, 2, this.n1w_1, value.fh_1);
    structuredEncoder.y1g(this.o1w_1);
  };
  protoOf(TripleSerializer_0).u1d = function (encoder, value) {
    return this.p1w(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).v1d = function (decoder) {
    var composite = decoder.x1g(this.o1w_1);
    if (composite.m1h()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.d1w_1 = keySerializer;
    this.e1w_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).f1w = function (encoder, value) {
    var structuredEncoder = encoder.x1g(this.t1d());
    structuredEncoder.n1i(this.t1d(), 0, this.d1w_1, this.z1v(value));
    structuredEncoder.n1i(this.t1d(), 1, this.e1w_1, this.b1w(value));
    structuredEncoder.y1g(this.t1d());
  };
  protoOf(KeyValueSerializer).u1d = function (encoder, value) {
    return this.f1w(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(KeyValueSerializer).v1d = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.t1d();
    var composite = decoder.x1g(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.m1h()) {
        var key = composite.k1h(this.t1d(), 0, this.d1w_1);
        var value = composite.k1h(this.t1d(), 1, this.e1w_1);
        tmp$ret$0 = this.c1w(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.n1h(this.t1d());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.k1h(this.t1d(), 0, this.d1w_1);
            break;
          case 1:
            value_0 = composite.k1h(this.t1d(), 1, this.e1w_1);
            break;
          default:
            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.c1w(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.y1g(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.q1w_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_5(Companion_getInstance_1()));
  }
  protoOf(ULongSerializer).t1d = function () {
    return this.q1w_1;
  };
  protoOf(ULongSerializer).r1w = function (encoder, value) {
    var tmp = encoder.c1i(this.q1w_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.w1h(tmp$ret$0);
  };
  protoOf(ULongSerializer).u1d = function (encoder, value) {
    return this.r1w(encoder, value instanceof ULong ? value.ii_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).s1w = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.u1g(this.q1w_1).o1g();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).v1d = function (decoder) {
    return new ULong(this.s1w(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.t1w_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_7(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).t1d = function () {
    return this.t1w_1;
  };
  protoOf(UIntSerializer).u1w = function (encoder, value) {
    var tmp = encoder.c1i(this.t1w_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.v1h(tmp$ret$0);
  };
  protoOf(UIntSerializer).u1d = function (encoder, value) {
    return this.u1w(encoder, value instanceof UInt ? value.wh_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).v1w = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.u1g(this.t1w_1).n1g();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).v1d = function (decoder) {
    return new UInt(this.v1w(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.w1w_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_9(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).t1d = function () {
    return this.w1w_1;
  };
  protoOf(UShortSerializer).x1w = function (encoder, value) {
    var tmp = encoder.c1i(this.w1w_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.u1h(tmp$ret$0);
  };
  protoOf(UShortSerializer).u1d = function (encoder, value) {
    return this.x1w(encoder, value instanceof UShort ? value.ui_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).y1w = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.u1g(this.w1w_1).m1g();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).v1d = function (decoder) {
    return new UShort(this.y1w(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.z1w_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_11(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).t1d = function () {
    return this.z1w_1;
  };
  protoOf(UByteSerializer).a1x = function (encoder, value) {
    var tmp = encoder.c1i(this.z1w_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.t1h(tmp$ret$0);
  };
  protoOf(UByteSerializer).u1d = function (encoder, value) {
    return this.a1x(encoder, value instanceof UByte ? value.kh_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).b1x = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.u1g(this.z1w_1).l1g();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).v1d = function (decoder) {
    return new UByte(this.b1x(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).t1e = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.s1e(kClass, typeArgumentsSerializers) : $super.s1e.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
    SerializersModule.call(this);
    this.d1x_1 = class2ContextualFactory;
    this.e1x_1 = polyBase2Serializers;
    this.f1x_1 = polyBase2DefaultSerializerProvider;
    this.g1x_1 = polyBase2NamedSerializers;
    this.h1x_1 = polyBase2DefaultDeserializerProvider;
  }
  protoOf(SerialModuleImpl).v1i = function (baseClass, value) {
    if (!baseClass.q9(value))
      return null;
    var tmp0_safe_receiver = this.e1x_1.y1(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y1(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.f1x_1.y1(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).u1i = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.g1x_1.y1(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).y1(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.h1x_1.y1(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).s1e = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.d1x_1.y1(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i1x(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).c1x = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.d1x_1.t().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.u();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.v();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.l1x_1;
        collector.m1x(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.k1x(kclass, serial.j1x_1);
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this.e1x_1.t().g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.u();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.v();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = classMap.t().g();
      while (tmp0_iterator_1.h()) {
        var element_1 = tmp0_iterator_1.i();
        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.u();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.v();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.n1x(tmp_1, tmp_2, tmp$ret$9);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = this.f1x_1.t().g();
    while (tmp0_iterator_2.h()) {
      var element_2 = tmp0_iterator_2.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.u();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.v();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.o1x(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = this.h1x_1.t().g();
    while (tmp0_iterator_3.h()) {
      var element_3 = tmp0_iterator_3.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.u();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.v();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.p1x(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless() {
  }
  function WithTypeArguments() {
  }
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.q1x_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.q1x_1.equals(tmp0_other_with_cast.q1x_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.q1x_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(serializer=' + toString(this.q1x_1) + ')';
  };
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp_0;
      if (_this__u8e3s4 === PrimitiveClasses_getInstance().ia()) {
        tmp_0 = NothingSerializer_getInstance();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
        tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      }
      var tmp_1 = tmp_0;
      tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().pa());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.k1p(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          if (get_isInterface(_this__u8e3s4)) {
            tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
          } else {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function get_isInterface(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function createCache$1($factory) {
    this.r1x_1 = $factory;
  }
  protoOf(createCache$1).u1e = function (key) {
    return this.r1x_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.s1x_1 = $factory;
  }
  protoOf(createParametrizedCache$1).v1e = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      var value = this.s1x_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  //region block: post-declaration
  protoOf(SerialDescriptorImpl).w1e = get_isNullable;
  protoOf(SerialDescriptorImpl).d1f = get_isInline;
  protoOf(AbstractDecoder).k1h = decodeSerializableElement$default;
  protoOf(AbstractDecoder).w1g = decodeSerializableValue;
  protoOf(AbstractDecoder).m1h = decodeSequentially;
  protoOf(AbstractDecoder).o1h = decodeCollectionSize;
  protoOf(AbstractEncoder).r1i = encodeNotNullMark;
  protoOf(AbstractEncoder).s1i = beginCollection;
  protoOf(AbstractEncoder).o1i = encodeSerializableValue;
  protoOf(AbstractEncoder).q1i = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).t1i = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).w1e = get_isNullable;
  protoOf(ListLikeDescriptor).d1f = get_isInline;
  protoOf(ListLikeDescriptor).b1f = get_annotations;
  protoOf(MapLikeDescriptor).w1e = get_isNullable;
  protoOf(MapLikeDescriptor).d1f = get_isInline;
  protoOf(MapLikeDescriptor).b1f = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).w1e = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).d1f = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).a1p = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).w1e = get_isNullable;
  protoOf(NothingSerialDescriptor).d1f = get_isInline;
  protoOf(NothingSerialDescriptor).b1f = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).w1e = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).d1f = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).b1f = get_annotations;
  protoOf(TaggedDecoder).k1h = decodeSerializableElement$default;
  protoOf(TaggedDecoder).w1g = decodeSerializableValue;
  protoOf(TaggedDecoder).m1h = decodeSequentially;
  protoOf(TaggedDecoder).o1h = decodeCollectionSize;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = SerializationException_init_$Init$_0;
  _.$_$.b = SerializationException_init_$Create$_0;
  _.$_$.c = UnknownFieldException_init_$Create$;
  _.$_$.d = SEALED_getInstance;
  _.$_$.e = STRING_getInstance;
  _.$_$.f = CONTEXTUAL_getInstance;
  _.$_$.g = ENUM_getInstance;
  _.$_$.h = CLASS_getInstance;
  _.$_$.i = LIST_getInstance;
  _.$_$.j = MAP_getInstance;
  _.$_$.k = BooleanSerializer_getInstance;
  _.$_$.l = IntSerializer_getInstance;
  _.$_$.m = LongSerializer_getInstance;
  _.$_$.n = StringSerializer_getInstance;
  _.$_$.o = ListSerializer;
  _.$_$.p = MapSerializer;
  _.$_$.q = SetSerializer;
  _.$_$.r = get_nullable;
  _.$_$.s = serializer_1;
  _.$_$.t = serializer_10;
  _.$_$.u = serializer_8;
  _.$_$.v = serializer_12;
  _.$_$.w = serializer_6;
  _.$_$.x = PolymorphicKind;
  _.$_$.y = PrimitiveKind;
  _.$_$.z = PrimitiveSerialDescriptor;
  _.$_$.a1 = get_annotations;
  _.$_$.b1 = get_isInline;
  _.$_$.c1 = get_isNullable;
  _.$_$.d1 = SerialDescriptor;
  _.$_$.e1 = ENUM;
  _.$_$.f1 = buildSerialDescriptor;
  _.$_$.g1 = getContextualDescriptor;
  _.$_$.h1 = AbstractDecoder;
  _.$_$.i1 = AbstractEncoder;
  _.$_$.j1 = CompositeDecoder;
  _.$_$.k1 = CompositeEncoder;
  _.$_$.l1 = Decoder;
  _.$_$.m1 = Encoder;
  _.$_$.n1 = AbstractPolymorphicSerializer;
  _.$_$.o1 = ArrayListSerializer;
  _.$_$.p1 = ElementMarker;
  _.$_$.q1 = typeParametersSerializers;
  _.$_$.r1 = GeneratedSerializer;
  _.$_$.s1 = InlinePrimitiveDescriptor;
  _.$_$.t1 = NamedValueDecoder;
  _.$_$.u1 = PluginGeneratedSerialDescriptor;
  _.$_$.v1 = SerializerFactory;
  _.$_$.w1 = createAnnotatedEnumSerializer;
  _.$_$.x1 = jsonCachedSerialNames;
  _.$_$.y1 = throwMissingFieldException;
  _.$_$.z1 = EmptySerializersModule_0;
  _.$_$.a2 = contextual;
  _.$_$.b2 = SerializersModuleCollector;
  _.$_$.c2 = BinaryFormat;
  _.$_$.d2 = DeserializationStrategy;
  _.$_$.e2 = KSerializer;
  _.$_$.f2 = MissingFieldException;
  _.$_$.g2 = SealedClassSerializer;
  _.$_$.h2 = SerializationException;
  _.$_$.i2 = StringFormat;
  _.$_$.j2 = findPolymorphicSerializer;
  _.$_$.k2 = serializerOrNull_0;
  _.$_$.l2 = serializer_0;
  _.$_$.m2 = serializer;
  //endregion
  return _;
}));
